module.exports = __webpack_public_path__ + "static/finetouch-416334a11dec75f14da1aed2ff989200.jpg";